// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"bc133a4f","220":"bc133a4f","453":"401403f1","458":"bc133a4f","839":"bc133a4f"}[chunkId] + ".chunk.js";
};